exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time-bar{\n    background-color: rgba(0, 0, 0, 0.6);\n    position:absolute;\n    top:780px;left:0px;\n    width:100%;\n    min-height:50px;\n    /* border-radius:5px; */\n}\n\n.min-time-value{\n    color:white;\n    font-family:Arial;\n    font-size:10pt;\n    position:absolute;\n    left:10px;bottom:3px;\n}\n\n\n\n.max-time-value{\n    color:white;\n    font-family:Arial;\n    font-size:10pt;\n    position:absolute;\n    right:10px;bottom:3px;\n}\n\n\n.currentValueIndicator {\n    height: 13px;\n    width: 160px;\n    position: absolute;\n    bottom: 2px;\n    left:460px;\n    z-index: 1;\n    text-align:center;\n}\n\n.currentValueIndicatorContent {\n    font-family:Arial;\n    border: 1px solid #444;\n    background-color: #0065A2;\n    color: white;\n    padding: 4px;\n    border-radius: 4px;\n    /* font-size: 9pt; */\n    font-size: 13pt;\n    margin-left: auto;\n    margin-right: auto;\n    display:inline-block;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/time-bar/time-bar.component.css
// module id = ../../../../../src/app/components/time-bar/time-bar.component.css
// module chunks = main